
import React from 'react';
import './Cards.css';
import CardItem from './CardItem';
import Bidayuh from '../../images/bidayuh12.png';
import Iban from '../../images/iban2.jpg';
import Ulu from '../../images/ulu 1.png';
import Malay from '../../images/malay4.png';
import Melanau from '../../images/melanau2.png';


function Cards() {
  return (
    <div className='cards'>
      <h1> OUR CULTURE </h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src= {Bidayuh}
              text='Known for their hospitality and warm smile, "Bidayuh" is a collective name for several indigenous group of people living in the Southern part of Sarawak. The name "Bidayuh" means "People of the Land".'
              label='BIDAYUH'
              path='/Bidayuh'
            />
            <CardItem
              src= {Iban}
              text='Formerly known as the Sea Dayaks, the Iban are famous for their head-hunting past, massive ironwood longhouses, ornate body tattooing, wonderful weaving skills, adn their popent rice wine. '
              label='IBAN'
              path='/Iban'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src={Ulu}
              text='The Orang Ulu is a collective name to represent the various ethnic sub-groups. They include the Kelabits, Lun Bawangs, Kenyahs, Kayans, Bisayas, Penans.'
              label='ORANG ULU'
              path='/Ulu'
            />
            <CardItem
              src= {Malay}
              text='Malays are the third largest group of people in Sarawak. In Kuching, the Malay villages along the riverside next to the Fort Margherita have some beautiful traditional and modern architectures. This is especially noteworthy as they are reserved, intact communities withing a modern city.'
              label='MALAY'
              path='/Melayu'
            />
            <CardItem
              src={Melanau}
              text='Amongst the earliest settlers in Sarawak, the Melanaus used to live close to the sea. As a result, they were exposed to many pirate attacks, hence they built sturdy houses 40ft above the ground.'
              label='MELANAU'
              path='/Melanau'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;